// Code review - In Progress
// Documentation - In Progress
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import toast from "react-hot-toast";
import { BindAPI, ImageAPI, IUDAPI } from "../services/APIConnection";
import FileUpload from "../ReusableComponents/FileUpload";
import { useNavigate } from "react-router-dom";
import Loader from "../ReusableComponents/Loader";
import Checkbox from "../ReusableComponents/Checkbox";
import { sub } from "date-fns";
import ErrorPopup from "../ReusableComponents/ErrorPopup";

const Registerpopup = forwardRef(({ closePopup }, ref) => {
  const navigate = useNavigate();
  const [pendingUpload, setPendingUpload] = useState(false);
  const [bindContactNoAndEmailDatas, setBindContactNoAndEmailDatas] = useState(
    []
  );
  const [clientsBulkUploadData, setClientsBulkUploadData] = useState("");
  const [checkboxStatus, setCheckboxStatus] = useState();
  const [clientsBulkUploadDataNew, setClientsBulkUploadDataNew] = useState([]);
  const [buttonDisable, setButtonDisable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
   const [clearVal, setClearVal] = useState(false);
   const [isOpen, setIsOpen] = useState(false);
  const [clientsFields, setClientsFields] = useState({
    clientsId: "CLT",
    clientsName: "",
    address: "",
    country: "1",
    state: "",
    city: "",
    propertyType: "",
    pinCode: "",
    noOfUsersRequired: "",
    subscriptionPeriod: "",
    date: new Date(),
    firstName: null,
    LastName: "",
    showImage: "",
    designation: "",
    contactNumber: "",
    email: "",
    gst: "",
    termsandConditions: ` By registering your hotel on stay-cool.com, you agree to
                    provide accurate and up-to-date information about your
                    property, including room details, availability, pricing,
                    amenities, photos, and policies. You confirm that you are
                    authorized to represent the hotel and that the property
                    complies with all applicable local laws, safety regulations,
                    and licensing requirements. You are solely responsible for
                    managing bookings, updating availability, honoring confirmed
                    reservations, and handling cancellations, no-shows, and
                    customer service in accordance with the policies you define
                    and share with us. The platform may charge a commission for
                    each successful booking, as mutually agreed upon during the
                    onboarding process. Payouts will be made to the bank account
                    you provide, following the selected payout schedule. You
                    grant us the right to use your property’s content—including
                    images, descriptions, and branding—for listing and marketing
                    purposes. You acknowledge that guest reviews and ratings
                    will be visible on your listing and agree not to manipulate
                    or misrepresent guest feedback in any way. The platform is
                    not liable for guest behavior, service disputes, or indirect
                    damages resulting from your hotel’s operations. We reserve
                    the right to suspend or remove your listing if there is a
                    breach of these terms, repeated customer complaints, or
                    non-compliance with applicable laws. You may also request
                    deactivation by notifying us in writing. This agreement is
                    governed by the laws of [Jurisdiction], and any disputes
                    will be handled in the courts of [City, State]. Continued
                    use of the platform implies acceptance of the most current
                    version of these Terms and Conditions. For support, contact
                    us at support@stay-cool.com.`,
  });

  const [clientsFieldsError, setClientsFieldsError] = useState({
    clientsIdError: "",
    clientsNameError: "",
    propertyTypeError: "",
    addressError: "",
    countryError: "",
    stateError: "",
    cityError: "",
    pinCodeError: "",
    noOfUsersRequiredError: "",
    subscriptionPeriodError: "",
    dateError: "",
    firstNameError: "",
    LastNameError: "",
    designationError: "",
    contactNumberError: "",
    emailError: "",
    showImageError: "",
    gstError: "",
    propertyPhotoError: "",
    termsandConditionsError: "",
  });

  const handleCheckboxChange = (selected) => {
    setCheckboxStatus(selected);
    setClientsFieldsError({
      ...clientsFieldsError,
      termsandConditionsError: "",
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      setClientsFields({ ...clientsFields, date: formattedDate });
    };

    fetchData();
  }, []);

  const handleClientsFieldsChange = (value, name) => {
    setClientsFields({
      ...clientsFields,
      [name]: value,
    });
  };

  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);

  // View details start

  const [submitVisibleButton, setSubmitVisibleButton] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [getStateDatas, setGetStateDatas] = useState([]);
  const [getCityDatas, setGetCityDatas] = useState([]);

  // view details end

  useEffect(() => {
    const fetchAllMasterData = async () => {
      try {
        // Fetch master data in one call
        const response = await BindAPI("MasterDataAPI/BindMasterDatas");
        const { data } = await BindAPI("ClientsAPI/BindClients");
        setBindContactNoAndEmailDatas(data?.Table2 ?? []);

        if (response?.data) {
          const { Table, Table1, Table2 } = response.data;

          // Country
          const countryDD =
            Table?.map((m) => ({
              value: m.MstCountryId,
              label: m.CountryName,
            })) || [];
          setCountryBindDD(countryDD);

          // State
          setGetStateDatas(Table1 || []);

          // Location
          setGetCityDatas(Table2 || []);
        }
      } catch (error) {
        console.error("Error fetching master data:", error);
      }

      // Designation
      try {
        const resDesignation = await BindAPI("MasterDataAPI/BindDesignation");
        if (resDesignation?.data?.Table) {
          const designationDD = resDesignation.data.Table.map((item) => ({
            value: item.MstDesignationId.toString(),
            label: item.Designation,
          }));
          setDesignationBindDD(designationDD);
        }
      } catch (error) {
        console.error("Error fetching designation data:", error);
      }

      // Property Type
      try {
        const resType = await BindAPI("MasterDataAPI/BindPropertyType");
        if (resType?.data?.Table) {
          const propertyTypeOptions = resType.data.Table.map((item) => ({
            value: item.MstPropertyTypeId.toString(),
            label: item.PropertyType,
          }));
          setPropertyTypeBindDD(propertyTypeOptions);
        }
      } catch (error) {
        console.error("Error fetching property propertyType data:", error);
      }
    };

    fetchAllMasterData();
  }, []);

  useEffect(() => {
    if (!clientsFields.country || getStateDatas.length === 0) return;

    const filteredStates = getStateDatas
      .filter((item) => item.MstCountryId == clientsFields.country)
      .map((item) => ({
        value: item.MstStateId,
        label: item.State,
      }));

    setStateBindDD(filteredStates);
  }, [clientsFields.country, getStateDatas]);

  useEffect(() => {
    if (!clientsFields.state || getCityDatas.length === 0) return;

    const filteredCitys = getCityDatas
      .filter((item) => item.MstStateId == clientsFields.state)
      .map((item) => ({
        value: item.MstCityId,
        label: item.City,
      }));

    setCityBindDD(filteredCitys);
  }, [clientsFields.state, getCityDatas]);

  const cancel = () => {
    setIsLoading(false);
    setClearVal(true)
    setSubmitBtnDisabled(false);
    navigate("/");
    closePopup();
    clear();
  };

  useEffect(() => {
    clear(); 
  }, []);
  const clear = () => {
    setCheckboxStatus();
    setShowImage("");
    fileInputRef.current.value = ""; 
    setSelectedFiles([]);
    setClientsFields({
      clientsId: "CLT",
      clientsName: "",
      address: "",
      country: "1",
      state: "",
      city: "",
      propertyType: "",
      pinCode: "",
      date: new Date(),
      firstName: "",
      LastName: "",
      showImage: "",
      designation: "",
      contactNumber: "",
      email: "",
      gst: "",
      termsandConditions: ` By registering your hotel on stay-cool.com, you agree to
                    provide accurate and up-to-date information about your
                    property, including room details, availability, pricing,
                    amenities, photos, and policies. You confirm that you are
                    authorized to represent the hotel and that the property
                    complies with all applicable local laws, safety regulations,
                    and licensing requirements. You are solely responsible for
                    managing bookings, updating availability, honoring confirmed
                    reservations, and handling cancellations, no-shows, and
                    customer service in accordance with the policies you define
                    and share with us. The platform may charge a commission for
                    each successful booking, as mutually agreed upon during the
                    onboarding process. Payouts will be made to the bank account
                    you provide, following the selected payout schedule. You
                    grant us the right to use your property’s content—including
                    images, descriptions, and branding—for listing and marketing
                    purposes. You acknowledge that guest reviews and ratings
                    will be visible on your listing and agree not to manipulate
                    or misrepresent guest feedback in any way. The platform is
                    not liable for guest behavior, service disputes, or indirect
                    damages resulting from your hotel’s operations. We reserve
                    the right to suspend or remove your listing if there is a
                    breach of these terms, repeated customer complaints, or
                    non-compliance with applicable laws. You may also request
                    deactivation by notifying us in writing. This agreement is
                    governed by the laws of [Jurisdiction], and any disputes
                    will be handled in the courts of [City, State]. Continued
                    use of the platform implies acceptance of the most current
                    version of these Terms and Conditions. For support, contact
                    us at support@stay-cool.com.`,
    });
    setClientsFieldsError({
      clientsIdError: "",
      clientsNameError: "",
      addressError: "",
      countryError: "",
      stateError: "",
      cityError: "",
      pinCodeError: "",
      dateError: "",
      firstNameError: "",
      LastNameError: "",
      designationError: "",
      contactNumberError: "",
      emailError: "",
      showImageError: "",
      gstError: "",
      propertyPhotoError: "",
      termsandConditionsError: "",
    });
  };
  const API_BASE_URL = window.location.protocol === "https:" ? "https" : "http";
  const [imageDisabled, setImageDisabled] = useState(false);
  const [fileDisabled, setFileDisabled] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showImage, setShowImage] = useState("");
  const [showImageError, setShowImageError] = useState("");
  const fileInputRef = useRef(null);
  const MAX_FILE_SIZE_MB = 2;
  const ALLOWED_FORMATS = ["image/jpeg", "image/jpg", "image/png"];

  const isFileFormatAllowed = (file) => ALLOWED_FORMATS.includes(file.type);

  const isFileSizeBelowLimit = (file) =>
    file.size <= MAX_FILE_SIZE_MB * 1024 * 1024;

  const handleFileChange = (event) => {
  // Block adding new photo if previous photo is selected but not yet uploaded
  if (pendingUpload) {
    toast.error("Please upload the selected photo before adding a new one", {
      duration: 3000,
      position: "top-center",
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    return;
  }
  setImageDisabled(false);
  const files = event.target.files;

  const selectedFilesLimited = Array.from(files)
    .filter(
      (file) =>
        isFileFormatAllowed(file) &&
        isFileSizeBelowLimit(file) &&
        !selectedFiles.some(
          (selectedFile) =>
            selectedFile.file.name === file.name &&
            selectedFile.file.size === file.size
        )
    )
    .slice(0, 3);

  if (selectedFiles.length + selectedFilesLimited.length > 3) {
    setImageDisabled(true);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    toast.error("Cannot select more than 3 files", {
      duration: 3000,
      position: "top-center",
    });
    return;
  }

  if (selectedFilesLimited.length > 0) {
    setPendingUpload(true); // Mark as pending upload
  }

  setSelectedFiles((prevFiles) => [
    ...prevFiles,
    ...selectedFilesLimited.map((file) => ({
      file,
      previewUrl: URL.createObjectURL(file),
    })),
  ]);

  const unsupportedFormatFiles = Array.from(files).filter(
    (file) => !isFileFormatAllowed(file)
  );
  if (unsupportedFormatFiles.length > 0) {
    const unsupportedFilesNames = unsupportedFormatFiles
      .map((file) => file.name)
      .join(", ");
    toast.error(`Unsupported file format: ${unsupportedFilesNames}`, {
      duration: 4000,
      position: "top-center",
    });
  }

  const oversizedFiles = Array.from(files).filter(
    (file) => !isFileSizeBelowLimit(file)
  );
  if (oversizedFiles.length > 0) {
    const oversizedFilesNames = oversizedFiles
      .map((file) => file.name)
      .join(", ");
    toast.error(`File size exceeds the limit (${MAX_FILE_SIZE_MB}MB)`, {
      duration: 4000,
      position: "top-center",
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setFileDisabled(false);
    if (selectedFilesLimited.length === 0) {
      setPendingUpload(false); // No valid files were added, don't block
    }
  }
};
  // const handleFileChange = (event) => {
  //   // Block adding new photo if previous photo is selected but not yet uploaded
  //   if (selectedFiles.length > 0 && !showImage) {
  //     toast.error("Please upload the selected photo before adding a new one", {
  //       duration: 3000,
  //       position: "top-center",
  //     });
  //     if (fileInputRef.current) {
  //       fileInputRef.current.value = "";
  //     }
  //     return;
  //   }
  //   setImageDisabled(false);
  //   // setFileDisabled(true);
  //   const files = event.target.files;

  //   const selectedFilesLimited = Array.from(files)
  //     .filter(
  //       (file) =>
  //         isFileFormatAllowed(file) &&
  //         isFileSizeBelowLimit(file) &&
  //         !selectedFiles.some(
  //           (selectedFile) =>
  //             selectedFile.file.name === file.name &&
  //             selectedFile.file.size === file.size
  //         ) // Prevent duplicate files
  //     )
  //     .slice(0, 3);

  //   if (selectedFiles.length + selectedFilesLimited.length > 3) {
  //     setImageDisabled(true);
  //     if (fileInputRef.current) {
  //       fileInputRef.current.value = ""; // Clears the file input value
  //     }
  //     toast.error("Cannot select more than 3 files", {
  //       duration: 3000,
  //       position: "top-center",
  //     });
  //     return;
  //   }

  //   setSelectedFiles((prevFiles) => [
  //     ...prevFiles,
  //     ...selectedFilesLimited.map((file) => ({
  //       file,
  //       previewUrl: URL.createObjectURL(file),
  //     })),
  //   ]);

  //   const unsupportedFormatFiles = Array.from(files).filter(
  //     (file) => !isFileFormatAllowed(file)
  //   );
  //   if (unsupportedFormatFiles.length > 0) {
  //     const unsupportedFilesNames = unsupportedFormatFiles
  //       .map((file) => file.name)
  //       .join(", ");
  //     const errorMessage = `Unsupported file format: ${unsupportedFilesNames}`;
  //     toast.error(errorMessage, {
  //       duration: 4000,
  //       position: "top-center",
  //     });
  //   }

  //   const oversizedFiles = Array.from(files).filter(
  //     (file) => !isFileSizeBelowLimit(file)
  //   );
  //   if (oversizedFiles.length > 0) {
  //     const oversizedFilesNames = oversizedFiles
  //       .map((file) => file.name)
  //       .join(", ");
  //     const errorMessage = `File size exceeds the limit (${MAX_FILE_SIZE_MB}MB)`;
  //     toast.error(errorMessage, {
  //       duration: 4000,
  //       position: "top-center",
  //     });
      
  // if (fileInputRef.current) {
  //   fileInputRef.current.value = ""; // 🔑 allow reselect
  // }

  // setFileDisabled(false); // 🔑 keep enabled
  //   }
  // };

  const handleUpload = async () => {
    setImageDisabled(true);
    if (selectedFiles.length === 0) {
      // Handle case where no files are selected
      toast.error("Please select files to upload", {
        duration: 2000,
        position: "top-center",
      });
      return;
    }

    const formData = new FormData();

    // Append each selected file to the formData
    for (let i = 0; i < selectedFiles.length; i++) {
      formData.append("PropertyPhoto", selectedFiles[i].file);
    }

    try {
      const response = await ImageAPI(
        formData,
        "ClientsAPI/PropertyPhotoUpload"
      );

      // Check if the API response contains image URLs
      if (Array.isArray(response.data) && response.data.length > 0) {
        // Update state with image URLs

        const allImageUrls = [
          ...selectedFiles.map((fileObj) => fileObj.previewUrl),
          ...response.data.map((fileUrl) => fileUrl),
        ];

        // Filter out URLs that start with 'blob:http://'
        const filteredImageUrls = allImageUrls.filter(
          (url) => !url.startsWith(`blob:${API_BASE_URL}://`)
        );

        const imageUrlString = filteredImageUrls.join(",");

        setShowImage(imageUrlString);
        toast.success("Images uploaded successfully 📷", {
          duration: 3000,
          position: "top-center",
        });
        setPendingUpload(false);
        setFileDisabled(false);
        setShowImageError("");
      } else {
        toast.error("Failed to upload images 👎", {
          duration: 2000,
          position: "top-center",
        });
      }
    } catch (error) {
      toast.error("Failed to upload images 👎", {
        duration: 2000,
        position: "top-center",
      });
    }
  };
  const handleImageCancel = (index) => {
    setImageDisabled(true);
    setFileDisabled(false);
    const updatedTableData = [...selectedFiles];
    updatedTableData.splice(index, 1);
    setSelectedFiles(updatedTableData);
    if (updatedTableData.length === 0) {
    setPendingUpload(false); // No more pending files
  }
    const formData = new FormData();
     if (updatedTableData.length > 0) {
    setImageDisabled(false);   // enable upload button
    setPendingUpload(true);    // still files pending
  } else {
    setImageDisabled(false);   // no files → keep enabled but harmless
    setPendingUpload(false);
  }
    const imageUrlArray = [];

    for (let i = 0; i < updatedTableData.length; i++) {
      imageUrlArray.push(updatedTableData[i].previewUrl);
    }
    const imageUrlString = imageUrlArray.join(",");

    setShowImage(imageUrlString);
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clears the file input value
    }
  };
  const handleShowImage = (showImage) => {
    // Set showImage to an empty string if showImage is falsy
    setClientsFields({
      ...clientsFields,
      showImage: showImage || "", // This will set to showImage if it's truthy, else ""
    });

    // Reset any error related to showImage
    setClientsFieldsError({ ...clientsFieldsError, showImageError: "" });
  };
  const [cityBindDD, setCityBindDD] = useState([]);
  const [stateBindDD, setStateBindDD] = useState([]);
  const [countryBindDD, setCountryBindDD] = useState([]);
  const [propertyTypeBindDD, setPropertyTypeBindDD] = useState([]);
  const [designationBindDD, setDesignationBindDD] = useState([]);
  const trueFunction = () => {
    setSubmitBtnDisabled(false); // Call to re-enable the submit button
  };
  const handleSubmit = async (items, flag) => {
    setIsLoading(true);
    setSubmitBtnDisabled(true);
    if (flag == 1 || flag == 2) {
      const isFormError = {
        ...clientsFieldsError,
        propertyTypeError: clientsFields.propertyType
          ? ""
          : "Select Property Type",
        clientsNameError:
          clientsFields.clientsName && clientsFields.clientsName.length > 0
            ? ""
            : "Enter Name",
        addressError:
          clientsFields.address && clientsFields.address.length > 0
            ? ""
            : "Enter Address",
        countryError: clientsFields.country ? "" : "Select Country",
        stateError: clientsFields.state ? "" : "Select State",
        cityError: clientsFields.city ? "" : "Select City",
        pinCodeError:
          clientsFields.pinCode?.trim().length > 0 ? "" : "Enter Pin Code",
        noOfUsersRequiredError:
          clientsFields.noOfUsersRequired &&
          clientsFields.noOfUsersRequired.length > 0
            ? ""
            : "Enter Number of Users Required",
        subscriptionPeriodError:
          clientsFields.subscriptionPeriod &&
          clientsFields.subscriptionPeriod.length > 0
            ? ""
            : "Enter Subscription Period (Months)",

        firstNameError:
          clientsFields.firstName && clientsFields.firstName.length > 0
            ? ""
            : "Enter First Name",
        LastNameError:
          clientsFields.LastName && clientsFields.LastName.trim().length > 0
            ? ""
            : "Enter Last Name",

        contactNumberError:
          clientsFields.contactNumber && clientsFields.contactNumber.length > 0
            ? /^\+?[0-9]{7,15}$/.test(clientsFields.contactNumber)
              ? ""
              : "Only digits allowed, with optional + at start (7 to 15 digits)"
            : "Enter Contact Number",
        emailError:
          clientsFields.email.length > 0
            ? !updateScreenTitle &&
              bindContactNoAndEmailDatas.find(
                (x) =>
                  x.UserEmail.toLowerCase() ===
                  clientsFields.email.toLowerCase()
              )
              ? "Email Address already available"
              : ""
            : "Enter Email",

        contactPersonDesignationError: clientsFields.designation
          ? ""
          : "Select Designation",
        gstError:
          clientsFields.gst && clientsFields.gst.trim().length > 0
            ? ""
            : "Enter GST No. (Put NA if not applicable)",
        propertyPhotoError: showImage ? "" : "Please upload an image",
        termsandConditionsError:
          checkboxStatus && checkboxStatus.length > 0
            ? ""
            : "You must accept the terms and conditions",
      };
      setClientsFieldsError(isFormError);
      const isFormValid = Object.values(isFormError).every(
        (error) => error === ""
      );

      if (!isFormValid) {
        setIsLoading(false);
        setSubmitBtnDisabled(false);
        setIsOpen(true);
        return; // Prevent popup close or submission
      }
      if (isFormValid) {
        setIsLoading(true);
        setSubmitBtnDisabled(true);
        const clientsPayload = {
          mstClientId: 0,
          propertyType: parseInt(clientsFields.propertyType) || 0,
          name: clientsFields.clientsName,
          address: clientsFields.address,
          mstCountryId: parseInt(clientsFields.country) || 0,
          mstStateId: parseInt(clientsFields.state) || 0,
          mstCityId: parseInt(clientsFields.city) || 0,
          pinCode: clientsFields.pinCode,
          noofUsersRequired: clientsFields.noOfUsersRequired,
          subscriptionPeriodMonths: clientsFields.subscriptionPeriod,
          firstName: clientsFields.firstName,
          lastName: clientsFields.LastName,
          designation: parseInt(clientsFields.designation) || 0,
          contactNumber: clientsFields.contactNumber,
          email: clientsFields.email,
          logo: clientsFields.showImage,
          propertyPhoto: showImage,
          termsandConditions:
            checkboxStatus && checkboxStatus.length > 0
              ? clientsFields.termsandConditions
              : "",
          encryptedPwd: "1234",
          selectedUsers: '',
          bulkUpload: JSON.stringify(clientsBulkUploadDataNew),
          gstno: clientsFields.gst,
          createdBy: parseInt(createdBy) || 0,
          flag: flag,
        };

        const response = await IUDAPI(
          [clientsPayload],
          "ClientsAPI/IUDClients"
        );

        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success(" Registration Successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setSubmitVisibleButton(true);
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed To Assessee Registration 👎", {
              duration: 2000,
              position: "top-center",
            });
            // Don't close popup on error
          }
        }
      }
    }
  };
  useImperativeHandle(ref, () => ({
    childFunction() {
      handleSubmit(0, 1);
      setSubmitBtnDisabled();
    },
    childCancelFunction() {
      cancel();
    },
  }));

  useEffect(() => {
    const getMenuTableDatas = async () => {
      let rightsResponse;
      try {
        rightsResponse = await BindAPI(
          "RoleVsCapabilityAPI/BindRoleVsCapability"
        );
        const response = await BindAPI("RoleVsCapabilityAPI/BindScreenMenu");
        const organizedData = {};

        const processMenuData = (menuHeadingId) => {
          const filteredData = response.data.Table.filter(
            (item) => item.MstMenuHeadingId === menuHeadingId
          );

          const menuList = {};

          filteredData.forEach((item) => {
            if (!menuList[item.MenuName]) {
              menuList[item.MenuName] = {
                MenuName: item.MenuName,
                MstMenuId: item.MainMenuId ? null : item.MstMenuId,
                MainMenuId: item.MainMenuId,
                MstMenuHeadingId: item.MstMenuHeadingId,
                checked:
                  item.MainMenuId && item.SubMenu && item.SubMenu.length > 0
                    ? null
                    : [],
                SubMenu: [],
                View: item.View,
                Add: item.Add,
                Edit: item.Edit,
                Delete: item.Delete,
                Inactive: item.Inactive,
                Service: item.Service,
              };
            }

            const submenuFiltered = response.data.Table.filter(
              (subItem) =>
                subItem.MenuName === item.MenuName &&
                subItem.MainMenuId &&
                subItem.MstMenuHeadingId === menuHeadingId
            ).map((subItem) => ({
              SubMenu: subItem.SubMenu,
              MstMenuId: subItem.MstMenuId,
              MainMenuId: subItem.MainMenuId,
              MstMenuHeadingId: subItem.MstMenuHeadingId,
              checked: [],
              View: item.View,
              Add: item.Add,
              Edit: item.Edit,
              Delete: item.Delete,
              Inactive: item.Inactive,
              Service: item.Service,
            }));

            const arr = rightsResponse.data.Table.filter(
              (e) =>
                e.MstMenuId == menuList[item.MenuName].MstMenuId &&
                e.MstRoleId == 2
            );
            const checkedData =
              arr.length > 0
                ? {
                  add: arr[0].AddPermission === 1,
                  view: arr[0].ViewPermission === 1,
                  inActive: arr[0].BlockPermission === 1,
                  delete: arr[0].DeletePermission === 1,
                  edit: arr[0].ModifyPermission === 1,
                  service: arr[0].ProvideServicePermission === 1,
                  title:
                    arr[0].AddPermission === 1 &&
                    arr[0].ViewPermission === 1 &&
                    arr[0].BlockPermission === 1 &&
                    arr[0].DeletePermission === 1 &&
                    arr[0].ModifyPermission === 1 &&
                    arr[0].ProvideServicePermission === 1,
                }
                : {
                  title: false,
                  add: false,
                  view: false,
                  inActive: false,
                  delete: false,
                  edit: false,
                  service: false,
                };
            if (menuList[item.MenuName].checked !== null) {
              menuList[item.MenuName].checked.push(checkedData);
            }

            submenuFiltered.forEach((subItem) => {
              const subMenuItemExists = menuList[item.MenuName].SubMenu.some(
                (existingSubMenu) => existingSubMenu.SubMenu == subItem.SubMenu
              );
              if (!subMenuItemExists) {
                const arr = rightsResponse.data.Table.filter(
                  (e) => e.MstMenuId == subItem.MstMenuId && e.MstRoleId == 2
                );
                subItem.checked =
                  arr.length > 0
                    ? {
                      add: arr[0].AddPermission === 1,
                      view: arr[0].ViewPermission === 1,
                      inActive: arr[0].BlockPermission === 1,
                      delete: arr[0].DeletePermission === 1,
                      edit: arr[0].ModifyPermission === 1,
                      service: arr[0].ProvideServicePermission === 1,
                      title:
                        arr[0].AddPermission === 1 &&
                        arr[0].ViewPermission === 1 &&
                        arr[0].BlockPermission === 1 &&
                        arr[0].DeletePermission === 1 &&
                        arr[0].ModifyPermission === 1 &&
                        arr[0].ProvideServicePermission === 1,
                    }
                    : {
                      title: false,
                      add: false,
                      view: false,
                      inActive: false,
                      delete: false,
                      edit: false,
                      service: false,
                    };

                if (!subMenuItemExists) {
                  menuList[item.MenuName].SubMenu.push(subItem);
                }
              }
            });
          });

          return Object.values(menuList);
        };

        organizedData.Dashboard = processMenuData(1); // Dashboard
        organizedData.Administrator = processMenuData(2); // Administrator
        organizedData.Transaction = processMenuData(3); // Transaction
        organizedData.Report = processMenuData(4); // Reports

        setClientsBulkUploadData(organizedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    getMenuTableDatas();
  }, [clientsFields.email]);

  const createdBy = sessionStorage.getItem("createdBy");

  const convertOrganizedMenuData = (menuData, handleRoleChange) => {
    const convertedMenuData = [];

    Object.keys(menuData).forEach((key) => {
      menuData[key].forEach((item) => {
        // Process main menu if MstMenuId is not null
        if (item.MstMenuId !== null) {
          convertedMenuData.push({
            MstRoleId: handleRoleChange,
            MstMenuHeadingId: item.MstMenuHeadingId,
            MstMenuId: item.MstMenuId,
            ViewPermission: item.checked?.[0]?.view ? 1 : 0,
            AddPermission: item.checked?.[0]?.add ? 1 : 0,
            ModifyPermission: item.checked?.[0]?.edit ? 1 : 0,
            DeletePermission: item.checked?.[0]?.delete ? 1 : 0,
            InActivePermission: item.checked?.[0]?.inActive ? 1 : 0,
            ProvideServicePermission: item.checked?.[0]?.service ? 1 : 0,
            CreatedBy: 0,
          });
        }

        // Process submenus if available
        if (item.SubMenu && item.SubMenu.length > 0) {
          item.SubMenu.forEach((submenu) => {
            if (submenu.MstMenuId !== null) {
              convertedMenuData.push({
                MstRoleId: handleRoleChange,
                MstMenuHeadingId:
                  submenu.MstMenuHeadingId || item.MstMenuHeadingId,
                MstMenuId: submenu.MstMenuId,
                ViewPermission: submenu.checked?.view ? 1 : 0,
                AddPermission: submenu.checked?.add ? 1 : 0,
                ModifyPermission: submenu.checked?.edit ? 1 : 0,
                DeletePermission: submenu.checked?.delete ? 1 : 0,
                InActivePermission: submenu.checked?.inActive ? 1 : 0,
                ProvideServicePermission: submenu.checked?.service ? 1 : 0,
                CreatedBy: 0,
              });
            }
          });
        }
      });
    });

    return convertedMenuData;
  };
  useEffect(() => {
    if (clientsBulkUploadData) {
      // make sure data is not null or undefined
      const convertedMenuData = convertOrganizedMenuData(
        clientsBulkUploadData,
        2
      );
      setClientsBulkUploadDataNew(convertedMenuData);
    }
  }, [clientsBulkUploadData]);
  return (
    <div class="w-full">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      <div class=" flex flex-col w-full">
        <div class={mainTable.clientMasterMainAdd}>
          <div class={mainTable.addShadowScreen}>
            <div class={mainTable.mainContentScreen}>
              <form class={mainTable.formForClientMaster}>
                <div class={mainTable.grid2}>
                  <AutoDropDown
                    title="Property Type"
                    options={propertyTypeBindDD}
                    placeholder="Select"
                    name="propertyType"
                    selectedOption={
                      clientsFields.propertyType
                        ? propertyTypeBindDD.find(
                            (x) => x.value == clientsFields.propertyType
                          )
                        : ""
                    }
                    Class="custom-class"
                    // // tabIndex="1"
                    classStar="text-red-500"
                    controlFunc={(value, e) => {
                      handleClientsFieldsChange(value.value, e.name);
                    }}
                    controlFuncBlur={() => {
                      setClientsFieldsError(() => ({
                        ...clientsFieldsError,
                        propertyTypeError: clientsFields.propertyType
                          ? ""
                          : "Select Property Type",
                      }));
                    }}
                    errorMessage={clientsFieldsError.propertyTypeError}
                  />
                  <InputText
                    inputType={"text"}
                    title={" Name"}
                    name={"clientsName"}
                    classStar={"text-red-500"}
                    maxLength={100}
                    content={clientsFields.clientsName}
                    controlFunc={(e) =>
                      setClientsFields({
                        ...clientsFields,
                        clientsName: e.target.value,
                      })
                    }
                    controlFuncBlur={() => {
                      setClientsFieldsError((clientsFieldsError) => ({
                        ...clientsFieldsError,
                        clientsNameError:
                          clientsFields.clientsName &&
                          clientsFields.clientsName.length > 0
                            ? ""
                            : "Enter Name",
                      }));
                    }}
                    errorMessage={clientsFieldsError.clientsNameError}
                  />
                  <InputText
                    inputType={"text"}
                    title={"Address"}
                    maxLength={500}
                    name={"address"}
                    classStar={"text-red-500"}
                    content={clientsFields.address}
                    controlFunc={(e) =>
                      setClientsFields({
                        ...clientsFields,
                        address: e.target.value,
                      })
                    }
                    controlFuncBlur={() => {
                      setClientsFieldsError((clientsFieldsError) => ({
                        ...clientsFieldsError,
                        addressError:
                          clientsFields.address &&
                          clientsFields.address.length > 0
                            ? ""
                            : "Enter Address",
                      }));
                    }}
                    errorMessage={clientsFieldsError.addressError}
                  />
                  <AutoDropDown
                    title="Country"
                    options={countryBindDD}
                    placeholder="Select"
                    name="country"
                    selectedOption={countryBindDD.find(
                      (x) => x.value == clientsFields.country
                    )}
                    Class="custom-class"
                    // // tabIndex="1"
                    classStar="text-red-500"
                    controlFunc={(value, e) => {
                      handleClientsFieldsChange(value.value, e.name);
                      setClientsFields({
                        ...clientsFields,
                        country: value.value,
                        state: "",
                        city: "",
                      });
                      setClientsFieldsError({
                        ...clientsFieldsError,
                        countryError: value ? "" : "Select Country",
                      });
                    }}
                    controlFuncBlur={() => {
                      setClientsFieldsError(() => ({
                        ...clientsFieldsError,
                        countryError: clientsFields.country
                          ? ""
                          : "Select Country",
                      }));
                    }}
                    errorMessage={clientsFieldsError.countryError}
                  />
                  <AutoDropDown
                    title="State"
                    options={stateBindDD}
                    placeholder="Select"
                    name="state"
                    selectedOption={
                      clientsFields.state
                        ? stateBindDD.find(
                          (x) => x.value == clientsFields.state
                        )
                        : ""
                    }
                    Class="p-0"
                    // // tabIndex="1"
                    classStar="text-red-500"
                    controlFunc={(value, e) => {
                      handleClientsFieldsChange(value.value, e.name);
                      setClientsFields({
                        ...clientsFields,
                        state: value.value,
                        city: "",
                      });
                      setClientsFieldsError({
                        ...clientsFieldsError,
                        stateError: value ? "" : "Select State",
                      });
                    }}
                    controlFuncBlur={() => {
                      setClientsFieldsError(() => ({
                        ...clientsFieldsError,
                        stateError: clientsFields.state ? "" : "Select State",
                      }));
                    }}
                    errorMessage={clientsFieldsError.stateError}
                  />
                  <AutoDropDown
                    title="City"
                    options={cityBindDD}
                    placeholder="Select"
                    name="city"
                    selectedOption={
                      clientsFields.city
                        ? cityBindDD.find((x) => x.value == clientsFields.city)
                        : ""
                    }
                    Class="custom-class"
                    // // tabIndex="1"
                    classStar="text-red-500"
                    controlFunc={(value, e) => {
                      handleClientsFieldsChange(value.value, e.name);
                    }}
                    controlFuncBlur={() => {
                      setClientsFieldsError(() => ({
                        ...clientsFieldsError,
                        cityError: clientsFields.city ? "" : "Select City",
                      }));
                    }}
                    errorMessage={clientsFieldsError.cityError}
                  />
                  <InputText
                    inputType={"text"}
                    title={"Pin Code"}
                    name={"pinCode"}
                    classStar={"text-red-500"}
                    maxLength={10}
                    content={clientsFields.pinCode}
                    controlFunc={(e) => {
                      const inputVal = e.target.value;
                      setClientsFields({
                        ...clientsFields,
                        pinCode: inputVal,
                      });
                    }}
                    controlFuncBlur={() => {
                      setClientsFieldsError((clientsFieldsError) => ({
                        ...clientsFieldsError,
                        pinCodeError:
                          clientsFields.pinCode &&
                          clientsFields.pinCode.trim().length > 0
                            ? ""
                            : "Enter Pin Code",
                      }));
                    }}
                    errorMessage={clientsFieldsError.pinCodeError}
                  />
                  <InputText
                    inputType={"text"}
                    title={"Number of Users Required"}
                    maxLength={5}
                    name={"noOfUsersRequired"}
                    classStar={"text-red-500"}
                    content={clientsFields.noOfUsersRequired}
                    controlFunc={(e) =>
                      setClientsFields({
                        ...clientsFields,
                        noOfUsersRequired: e.target.value,
                      })
                    }
                    controlFuncBlur={() => {
                      setClientsFieldsError((clientsFieldsError) => ({
                        ...clientsFieldsError,
                        noOfUsersRequiredError:
                          clientsFields.noOfUsersRequired &&
                          clientsFields.noOfUsersRequired.trim().length > 0
                            ? ""
                            : "Enter Number of Users Required",
                      }));
                    }}
                    errorMessage={clientsFieldsError.noOfUsersRequiredError}
                  />
                  <InputText
                    inputType={"text"}
                    title={"Subscription Period (Months)"}
                    maxLength={3}
                    name={"subscriptionPeriod"}
                    classStar={"text-red-500"}
                    content={clientsFields.subscriptionPeriod}
                    controlFunc={(e) =>
                      setClientsFields({
                        ...clientsFields,
                        subscriptionPeriod: e.target.value,
                      })
                    }
                    controlFuncBlur={() => {
                      setClientsFieldsError((clientsFieldsError) => ({
                        ...clientsFieldsError,
                        subscriptionPeriodError:
                          clientsFields.subscriptionPeriod &&
                          clientsFields.subscriptionPeriod.trim().length > 0
                            ? ""
                            : "Enter Subscription Period (Months)",
                      }));
                    }}
                    errorMessage={clientsFieldsError.subscriptionPeriodError}
                  />
                  <InputText
                    inputType={"text"}
                    title={"GST No. (Put NA if not applicable)"}
                    maxLength={100}
                    name={"gst"}
                    classStar={"text-red-500"}
                    content={clientsFields.gst}
                    controlFunc={(e) =>
                      setClientsFields({
                        ...clientsFields,
                        gst: e.target.value,
                      })
                    }
                    controlFuncBlur={() => {
                      setClientsFieldsError((clientsFieldsError) => ({
                        ...clientsFieldsError,
                        gstError:
                          clientsFields.gst &&
                          clientsFields.gst.trim().length > 0
                            ? ""
                            : "Enter GST No. (Put NA if not applicable)",
                      }));
                    }}
                    errorMessage={clientsFieldsError.gstError}
                  />
                </div>
                <div class={mainTable.labelBold}>Contact Info</div>
                <hr class={mainTable.horizontalLine}></hr>
                <div class="grid gap-4 mb-6 md:grid-cols-2">
                  <InputText
                    inputType={"text"}
                    title={"First Name"}
                    name={"firstName"}
                    classStar={"text-red-500"}
                    maxLength={50}
                    content={clientsFields.firstName}
                    controlFunc={(e) =>
                      setClientsFields({
                        ...clientsFields,
                        firstName: e.target.value,
                      })
                    }
                    controlFuncBlur={(e) => {
                      setClientsFieldsError((clientsFieldsError) => ({
                        ...clientsFieldsError,
                        firstNameError:
                          clientsFields.firstName &&
                          clientsFields.firstName.length > 0
                            ? ""
                            : "Enter First Name",
                      }));
                    }}
                    errorMessage={clientsFieldsError.firstNameError}
                  />
                  <InputText
                    inputType={"text"}
                    title={"Last Name"}
                    name={"lastName"}
                    classStar={"text-red-500"}
                    maxLength={50}
                    content={clientsFields.LastName}
                    controlFunc={(e) =>
                      setClientsFields({
                        ...clientsFields,
                        LastName: e.target.value,
                      })
                    }
                    controlFuncBlur={(e) => {
                      const trimmedLastName =
                        clientsFields.LastName?.trim() || "";

                      setClientsFieldsError((clientsFieldsError) => ({
                        ...clientsFieldsError,
                        LastNameError:
                          trimmedLastName.length > 0 ? "" : "Enter Last Name",
                      }));
                    }}
                    errorMessage={clientsFieldsError.LastNameError}
                  />

                  <AutoDropDown
                    title="Designation"
                    options={designationBindDD}
                    placeholder="Select"
                    name="designation"
                    selectedOption={
                      clientsFields.designation
                        ? designationBindDD.find(
                          (x) => x.value == clientsFields.designation
                        )
                        : ""
                    }
                    Class="custom-class"
                    // // tabIndex="1"
                    classStar="text-red-500"
                    controlFunc={(value, e) => {
                      handleClientsFieldsChange(value.value, e.name);
                    }}
                    controlFuncBlur={() => {
                      setClientsFieldsError(() => ({
                        ...clientsFieldsError,
                        contactPersonDesignationError: clientsFields.designation
                          ? ""
                          : "Select Designation",
                      }));
                    }}
                    errorMessage={
                      clientsFieldsError.contactPersonDesignationError
                    }
                  />
                  <InputText
                    inputType={"text"}
                    title={"Contact Number"}
                    name={"contactNumber"}
                    classStar={"text-red-500"}
                    maxLength={15}
                    content={clientsFields.contactNumber}
                    controlFunc={(e) =>
                      setClientsFields({
                        ...clientsFields,
                        contactNumber: e.target.value,
                      })
                    }
                    controlFuncBlur={(e) => {
                      setClientsFieldsError((clientsFieldsError) => ({
                        ...clientsFieldsError,
                        contactNumberError:
                          clientsFields.contactNumber &&
                            clientsFields.contactNumber.length > 0
                            ? /^\+?[0-9]{7,15}$/.test(
                              clientsFields.contactNumber
                            )
                              ? ""
                              : "Only digits allowed, with optional + at start (7 to 15 digits)"
                            : "Enter Contact Number",
                      }));
                    }}
                    errorMessage={clientsFieldsError.contactNumberError}
                  />
                  <InputText
                    inputType={"text"}
                    title={"Email"}
                    classStar={"text-red-500"}
                    name={"email"}
                    maxLength={50}
                    content={clientsFields.email}
                    controlFunc={(e) =>
                      setClientsFields({
                        ...clientsFields,
                        email: e.target.value,
                      })
                    }
                    controlFuncBlur={(e) => {
                      setClientsFieldsError((clientsFieldsError) => {
                        let emailError = "";

                        if (
                          !clientsFields.email ||
                          clientsFields.email.length === 0
                        ) {
                          emailError = "Enter Email";
                        } else if (
                          !updateScreenTitle &&
                          bindContactNoAndEmailDatas.find(
                            (x) =>
                              x.UserEmail.toLowerCase() ===
                              clientsFields.email.toLowerCase()
                          )
                        ) {
                          emailError = "Email address already available";
                        }

                        return {
                          ...clientsFieldsError,
                          emailError,
                        };
                      });
                    }}
                    errorMessage={clientsFieldsError.emailError}
                  />
                </div>
                <FileUpload
                  title="Logo"
                  apiCall="ClientsAPI/LogoUpload"
                  modalName="Logo"
                  name="showImage"
                  disabledBtn={updateScreenTitle}
                  showImage={clientsFields.showImage}
                  showImageData={handleShowImage}
                  imageUploadedError={clientsFieldsError.showImageError}
                  imageShow={false}
                  limitMassage={
                    "Image size limit: 2MB. Accepted Image types:jpg, png, jpeg."
                  } 
                  MAX_FILE_SIZE_MB={2}
                  ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
                  clear={clearVal}
                />
                <div className={mainTable.grid2}>
                  <div>
                    <div className="mb-2">
                      <label className="block mb-2 text-sm capitalize font-medium text-neutral-700">
                        Property photo<span className="text-red-500">*</span>
                      </label>
                    </div>
                    <input
                      type="file"
                      ref={fileInputRef}
                      className={mainTable.input}
                      onChange={handleFileChange}
                      disabled={fileDisabled ? true : false}
                      accept=".jpg, .jpeg, .png"
                    />
                    {showImageError && (
                      <span className="text-red-500 text-sm font-medium">
                        {showImageError}
                      </span>
                    )}
                    {clientsFieldsError.propertyPhotoError && (
                      <span className="text-red-500 text-sm font-medium">
                        {clientsFieldsError.propertyPhotoError}
                      </span>
                    )}
                    {selectedFiles.length > 3 && (
                      <div className="text-red-500 text-sm font-medium">
                        Reached Maximum No. of Uploads
                      </div>
                    )}
                  </div>
                </div>

                <div>
                  {selectedFiles.length > 0 && (
                    <div class="flex gap-8">
                      {selectedFiles.map((item, index) => (
                        <div key={index} className="image-container">
                          <span
                            class="float-right cursor-pointer"
                            onClick={() => handleImageCancel(index)}
                          >
                            X
                          </span>
                          <img
                            src={item.previewUrl}
                            alt={`preview-${index}`}
                            class={`w-28 h-28 m-3`}
                          />
                          <span class={mainTable.label}>{item.file?.name}</span>
                          {index === selectedFiles.length - 1 && (
                            <input
                              type="button"
                              className={
                                imageDisabled
                                  ? mainTable.disabledSubmitButton
                                  : mainTable.submitButton
                              }
                              onClick={handleUpload}
                              disabled={imageDisabled ? true : false}
                              value="Upload"
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div className="border rounded-md shadow-sm">
                  <div class="my-1 py-2 max-lg:mt-4 mx-2 lg:mx-4 text-sm max-h-52 overflow-auto font-medium text-neutral-700">
                    {clientsFields.termsandConditions}
                  </div>
                  <div className="">
                    <div className=" text-xs p-2 lg:px-4 text-red-500 flex flex-col">
                      <Checkbox
                        Class="flex"
                        title="Terms and Conditions :"
                        options={[
                          {
                            value: 1,
                            label: "I accept the terms and conditions.",
                          },
                        ]}
                        controlFunc={handleCheckboxChange} // or a real function handler
                        disabled={false}
                        setName={"checkboxStatus"}
                        selectedOptions={checkboxStatus ? checkboxStatus : []}
                        // tabIndex="0"
                        errorMessage={
                          clientsFieldsError.termsandConditionsError
                        }
                      />
                          {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
                      {/* <div className="flex mb-2 justify-center">
                  <button
                    disabled={buttonDisable}
                    onClick={() => handleSubmit()}
                    className={`px-4 py-1 rounded text-white 
            ${
              buttonDisable
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-gray-600 hover:bg-gray-700"
            }`}
                  >
                    Completed Answers
                  </button>
                 
                </div> */}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default Registerpopup;
